var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoolerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.827 16.3791C9.77915 16.9086 8.60044 17.1235 7.43314 16.9979C6.26583 16.8723 5.15984 16.4115 4.24864 15.6712C3.33744 14.9309 2.66 13.9426 2.29807 12.8258C1.93614 11.7089 1.90521 10.5111 2.209 9.37709L7.621 10.8271C7.09147 9.77924 6.87655 8.60053 7.00216 7.43323C7.12777 6.26593 7.58856 5.15993 8.32889 4.24873C9.06923 3.33753 10.0575 2.66009 11.1743 2.29816C12.2912 1.93623 13.4889 1.9053 14.623 2.20909L13.173 7.62109C14.2208 7.09157 15.3996 6.87664 16.5669 7.00225C17.7342 7.12787 18.8402 7.58865 19.7514 8.32898C20.6626 9.06932 21.34 10.0576 21.7019 11.1744C22.0638 12.2913 22.0948 13.489 21.791 14.6231L16.379 13.1731C16.9085 14.2209 17.1234 15.3996 16.9978 16.5669C16.8722 17.7343 16.4114 18.8402 15.6711 19.7514C14.9308 20.6626 13.9425 21.3401 12.8257 21.702C11.7088 22.0639 10.5111 22.0949 9.377 21.7911L10.827 16.3791Z",
    stroke: "#596173",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V12.01",
    stroke: "#596173",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolerIcon);
export default __webpack_public_path__ + "static/media/coolerIcon.e5dac9c5981ac52fce30bbbfc79336c2.svg";
export { ForwardRef as ReactComponent };